export const RATE_LIMIT_MESSAGE_ID = 'return-message-cover';

export const RATE_LIMIT_MESSAGE = 'Too Many Requests – Please retry shortly.';

export const isRateLimitCode = (statusCode) => {
  return statusCode === 429;
};
